var windowId = '#confirmDeleteDialog';
var closeId = '#confirmDeleteClose';
var okBtnId = '#confirmDeleteOk';
var closeBtnId = '#confirmDeleteCloseBtn';
export function show(title, textConfirm) {
    $('#promtTitleDialog').text(title);
    $('#textConfirmDialog').text(textConfirm);
    return new Promise(function (resolve, reject) {
        $(windowId).addClass('modal-open');
        $(okBtnId).on('click', function () {
            resolve();
        });
        $(closeId).on('click', function () {
            close();
            reject();
        });
        $(closeBtnId).on('click', function () {
            close();
            reject();
        });
    })
        .finally(function () {
        clear();
    });
}
export function close() {
    clear();
    $(windowId).removeClass('modal-open');
}
export function setError(message) {
    $('#confirmDeleteText').html(message);
}
export function clear() {
    $('#confirmDeleteText').empty();
}
